<template>
  <footer class="site-footer">
    <div class="container default">
      <div class="footer-content">

<!--        <div class="footer-nav_container">-->
<!--          <ul class="footer-nav">-->
<!--            <li><a href="#close">About</a></li>-->
<!--            <li><a href="#close">Applications</a></li>-->
<!--            <li><a href="#close">Team</a></li>-->
<!--            <li><a href="#close">Achievements</a></li>-->
<!--          </ul>-->
<!--        </div>-->

        <div class="footer-logo_container">
          <a href="#close" class="footer-logo">
            <img src="../../assets/logo_white.svg" alt="Tonti Laguna Logo">
          </a>
        </div>

        <div class="bottom-part">
          <div class="copyright">© 2017-{{ currentYear }} Copyright by Tonti Laguna, part of Netpeak Group</div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterBase",
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>

<style lang="scss" scoped>
  .site-footer {
    padding: 60px 0;
    background: #0d1620;
  }

  .footer-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;
  }

  .footer-nav_container {
    margin: 0 0 32px 0;
  }
  .footer-nav {
    li {
      margin-right: 60px;
      &:last-child {
        margin-right: 0;
      }
    }
    a {
      line-height: 1.5;
      text-transform: uppercase;
      color: #ffffff;
      &:hover {
        color: rgba(255, 255, 255, .7);
      }
    }
  }

  .footer-logo_container {
    margin-bottom: 42px;
  }
  .footer-logo {
    display: inline-flex;
  }

  .copyright {
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.6);
  }

  @media only screen and (max-width: 640px) {
    .site-footer {
      padding: 42px 0 50px 0;
    }

    .footer-nav_container {
      margin: 0 0 42px 0;
    }
    .footer-nav {
      flex-direction: column;
      li {
        margin: 0 0 16px 0;
        &:last-child {
          margin: 0;
        }
      }
    }

    .footer-logo_container {
      margin-bottom: 24px;
    }
  }
</style>